// Device refusals must survive closing the dialog and a reload in the same tab.
export const ATTEMPTS_KEY = "ft220.attempts";
export function createAttemptsStore(storage = () => globalThis.sessionStorage) {
  let memory = {};
  const read = () => {
    try {
      const saved = JSON.parse(storage().getItem(ATTEMPTS_KEY) || "{}");
      if (saved && typeof saved === "object" && !Array.isArray(saved)) memory = { ...saved, ...memory };
    } catch (_) { /* Storage may be unavailable in private mode. */ }
    return memory;
  };
  const remember = (inspectionId, zoneKey, shot) => {
    if (!shot || !Number.isInteger(shot.series) || !Number.isInteger(shot.attempt)) return;
    read();
    const key = `${inspectionId}:${zoneKey}:${shot.series}`;
    const entries = Array.isArray(memory[key]) ? memory[key].slice() : [];
    const index = entries.findIndex(item => item.attempt === shot.attempt);
    const entry = { id: shot.id, series: shot.series, attempt: shot.attempt, state: shot.state, reason: shot.reason };
    if (index < 0) entries.push(entry);
    else entries.splice(index, 1, entry);
    memory[key] = entries;
    try { storage().setItem(ATTEMPTS_KEY, JSON.stringify(memory)); } catch (_) { /* Keep the in-memory copy. */ }
  };
  return {
    remember,
    history(inspectionId, zoneKey, latestShot) {
      if (latestShot) remember(inspectionId, zoneKey, latestShot);
      const prefix = `${inspectionId}:${zoneKey}:`;
      return Object.entries(read()).filter(([key]) => key.startsWith(prefix))
        .flatMap(([, entries]) => Array.isArray(entries) ? entries : [])
        .sort((a, b) => a.series - b.series || a.attempt - b.attempt);
    },
    clear() {
      memory = {};
      try { storage().removeItem(ATTEMPTS_KEY); } catch (_) { /* In-memory mode. */ }
    },
  };
}
export const damageControlAttempts = createAttemptsStore();
